import { useIntl } from 'react-intl';
import type { FieldValues } from 'react-hook-form';
import type { FieldConfig } from '../field';
import type { FieldHookArgs } from './model/types';

export function usePromoCodeFields<T extends FieldValues = FieldValues>({
    form: {
        control,
        formState: { errors },
    },
    prefix,
}: FieldHookArgs<T>): Record<string, FieldConfig> {
    const intl = useIntl();

    const fields: Record<string, FieldConfig> = {
        code: {
            id: `${prefix ?? ''}promo-code-code-field`,
            name: 'code',
            placeholder: intl.formatMessage({
                id: 'promo_code.enter_code',
                defaultMessage: 'Enter code',
            }),
            type: 'text',
            defaultValue: '',
            rules: {
                required: intl.formatMessage({
                    id: 'promo_code.error.required',
                    defaultMessage: 'Please provide a promo code',
                }),
            },
            error: errors.code,
            control,
        },
    };

    return fields;
}
